<app-header></app-header>
<div class="container">
	<main>
		<div id="view">
			<div id="page-document" class="ui container mb-4">
				<router-outlet></router-outlet>
			</div>
		</div>
	</main>
</div>
<app-footer></app-footer>
